import { useEffect, useState } from 'react'

import { DEFAULT_TIME_VALUE } from './config'
import type { TimeValue } from './types'

function clampMinutes(minutes: number, step: number): number {
  const rounded = Math.round(minutes / step) * step
  const maxMinute = Math.floor(59 / step) * step
  return Math.min(maxMinute, Math.max(0, rounded))
}

function parseValue(value: string | null): TimeValue {
  if (!value) return DEFAULT_TIME_VALUE

  const [hoursPart, minutesPart] = value.split(':')
  const hours = Number(hoursPart)
  const minutes = Number(minutesPart)

  if (Number.isNaN(hours) || Number.isNaN(minutes)) return DEFAULT_TIME_VALUE

  return { hours, minutes }
}

function toDraft(value: string | null, step: number): TimeValue {
  const parsed = parseValue(value)
  return {
    hours: Math.min(23, Math.max(0, parsed.hours)),
    minutes: clampMinutes(parsed.minutes, step),
  }
}

export function formatTimeValue(value: TimeValue): string {
  return `${String(value.hours).padStart(2, '0')}:${String(value.minutes).padStart(2, '0')}`
}

/**
 * Черновой выбор времени, живёт до нажатия «Готово». Минуты извне могут не попадать
 * в шаг барабана — округляем к ближайшей опции.
 */
export function useTimePickerDraft(isOpen: boolean, value: string | null, step: number) {
  const [draft, setDraft] = useState<TimeValue>(() => toDraft(value, step))

  useEffect(() => {
    if (isOpen) setDraft(toDraft(value, step))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  const setHours = (hours: number) => setDraft((prev) => ({ ...prev, hours }))
  const setMinutes = (minutes: number) => setDraft((prev) => ({ ...prev, minutes }))

  return { draft, setHours, setMinutes }
}
